import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  toggle() {
    const active = document.body.classList.toggle("focus-mode")
    this.element.classList.toggle("focus-mode-active")

    if (this.hasButtonTarget) {
      this.buttonTarget.textContent = active ? "Exit" : "Focus"
    }

    // Auto-scroll to bottom of moments
    const moments = document.getElementById("moments")
    if (moments) {
      setTimeout(() => { moments.scrollTop = moments.scrollHeight }, 100)
    }
  }
}
